import PeggyMarcone from '../images/peggy_marcone.jpg';
import LuannCameron from '../images/Luann_Cameron.jpg';
import CherylJorban from '../images/Cheryl_Jorban_New.jpg';
import DonnaProvost from '../images/Donna_Provost.png';
import TedJohnston from '../images/Ted_Johnston.jpg';

const Officers = [
    {
        id: 1,
        position: "President",
        name: "Donna Provost",
        unit: 186,
        term: 2026,
        photo: DonnaProvost
    },
    {
        id: 2,
        position: "First Vice President",
        name: "Peggy Marcone",
        unit: 418,
        term: 2026,
        photo: PeggyMarcone
    },
    {
        id: 3,
        position: "Second Vice President",
        name: "Ted Johnston",
        unit: 496,
        term: 2027,
        photo: TedJohnston
    },
    {
        id: 4,
        position: "Treasurer",
        name: "Cheryl Jorban",
        unit: 83,
        term: 2027,
        photo: CherylJorban
    },
    {
        id: 5,
        position: "Secretary",
        name: "Luann Cameron",
        unit: 41,
        term: 2027,
        photo: LuannCameron
    }
]

export default Officers; 